window.addEventListener('scroll', () => {
  const nav = document.getElementById('nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

(function () {
  const canvas = document.getElementById('motionCanvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let W, H, particles = [], lines = [], mouse = { x: -999, y: -999 };
  const NAVY = '#1B2A4A', TEAL = '#4AB3C0';

  function resize() {
    W = canvas.width = canvas.offsetWidth;
    H = canvas.height = canvas.offsetHeight;
  }

  class Particle {
    constructor() { this.reset(true); }
    reset(init) {
      this.x = Math.random() * W;
      this.y = init ? Math.random() * H : H + 20;
      this.r = Math.random() * 2.2 + .6;
      this.vx = (Math.random() - .5) * .3;
      this.vy = -(Math.random() * .5 + .2);
      this.alpha = Math.random() * .5 + .15;
      this.color = Math.random() > .55 ? TEAL : NAVY;
      this.life = 0;
      this.maxLife = Math.random() * 300 + 200;
    }
    update() {
      this.x += this.vx;
      this.y += this.vy;
      this.life++;
      const dx = mouse.x - this.x, dy = mouse.y - this.y, dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < 180 && dist > 0) {
        this.vx += dx / dist * .018;
        this.vy += dy / dist * .018;
      }
      if (this.y < -10 || this.life > this.maxLife) this.reset(false);
    }
    draw() {
      ctx.save();
      ctx.globalAlpha = this.alpha * (1 - this.life / this.maxLife);
      ctx.fillStyle = this.color;
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
  }

  class FloatingOrb {
    constructor(i) {
      this.i = i;
      this.x = W * (i === 0 ? .25 : i === 1 ? .72 : .5);
      this.y = H * (i === 0 ? .35 : i === 1 ? .6 : .15);
      this.baseX = this.x;
      this.baseY = this.y;
      this.r = i === 0 ? 220 : i === 1 ? 160 : 120;
      this.speed = Math.random() * .0008 + .0004;
      this.offset = Math.random() * Math.PI * 2;
      this.color = i % 2 === 0 ? TEAL : NAVY;
    }
    update(t) {
      this.x = this.baseX + Math.sin(t * this.speed + this.offset) * 60;
      this.y = this.baseY + Math.cos(t * this.speed * .7 + this.offset) * 40;
    }
    draw() {
      const g = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.r);
      g.addColorStop(0, this.color === TEAL ? 'rgba(74,179,192,.09)' : 'rgba(27,42,74,.07)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fillStyle = g;
      ctx.fill();
    }
  }

  class GridLine {
    constructor() { this.reset(); }
    reset() {
      this.horiz = Math.random() > .5;
      if (this.horiz) {
        this.x = 0; this.y = Math.random() * H; this.tx = W; this.ty = this.y;
      } else {
        this.y = 0; this.x = Math.random() * W; this.ty = H; this.tx = this.x;
      }
      this.prog = 0;
      this.speed = Math.random() * .003 + .001;
      this.alpha = Math.random() * .07 + .02;
      this.life = 0;
      this.maxLife = Math.random() * 200 + 150;
    }
    update() {
      this.prog = Math.min(1, this.prog + this.speed);
      this.life++;
      if (this.life > this.maxLife) this.reset();
    }
    draw() {
      const px = this.x + (this.tx - this.x) * this.prog;
      const py = this.y + (this.ty - this.y) * this.prog;
      ctx.save();
      ctx.globalAlpha = this.alpha * (1 - this.life / this.maxLife);
      ctx.strokeStyle = TEAL;
      ctx.lineWidth = .5;
      ctx.beginPath();
      ctx.moveTo(this.x, this.y);
      ctx.lineTo(px, py);
      ctx.stroke();
      ctx.restore();
    }
  }

  resize();
  for (let i = 0; i < 90; i++) particles.push(new Particle());
  const orbs = [new FloatingOrb(0), new FloatingOrb(1), new FloatingOrb(2)];
  for (let i = 0; i < 8; i++) lines.push(new GridLine());

  canvas.addEventListener('mousemove', e => {
    const r = canvas.getBoundingClientRect();
    mouse.x = e.clientX - r.left;
    mouse.y = e.clientY - r.top;
  });
  window.addEventListener('resize', resize);

  let t = 0;
  function frame() {
    ctx.clearRect(0, 0, W, H);
    t++;
    orbs.forEach(o => { o.update(t); o.draw(); });
    lines.forEach(l => { l.update(); l.draw(); });
    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x, dy = particles[i].y - particles[j].y, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 90) {
          ctx.save();
          ctx.globalAlpha = .06 * (1 - d / 90);
          ctx.strokeStyle = TEAL;
          ctx.lineWidth = .6;
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.stroke();
          ctx.restore();
        }
      }
      particles[i].update();
      particles[i].draw();
    }
    requestAnimationFrame(frame);
  }
  frame();
})();

document.querySelectorAll('.filter-tab').forEach(tab => {
  tab.addEventListener('click', function () {
    document.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});

const revEls = document.querySelectorAll('.rev');
if ('IntersectionObserver' in window) {
  const revObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  revEls.forEach(el => revObs.observe(el));
} else {
  revEls.forEach(el => el.classList.add('in'));
}

function moneyFromCents(cents) {
  return '$' + (Number(cents || 0) / 100).toFixed(2);
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function normalizeOption(value) {
  return String(value || '').trim().toLowerCase();
}

function getVariantData() {
  const el = document.getElementById('StrideVariantData');
  if (!el) return {};
  try { return JSON.parse(el.textContent || '{}'); }
  catch (error) { console.error('Stride variant JSON error:', error); return {}; }
}

const STRIDE_VARIANTS = getVariantData();

function getSelections(pid) {
  const card = document.querySelector('[data-pid="' + pid + '"]');
  if (!card) return { size: 'III', colour: 'Beige' };
  const sBtn = card.querySelector('.szpill.active');
  const sSw = card.querySelector('.pswatch.active');
  return {
    size: sBtn ? sBtn.textContent.trim() : 'III',
    colour: sSw ? (sSw.title || sSw.getAttribute('aria-label') || 'Beige').trim() : 'Beige'
  };
}

function findStrideVariant(pid, size, colour) {
  const product = STRIDE_VARIANTS[String(pid)];
  const variants = product && Array.isArray(product.variants) ? product.variants : [];
  const wantedSize = normalizeOption(size);
  const wantedColour = normalizeOption(colour);

  let match = variants.find(variant => {
    const values = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(normalizeOption);
    return values.includes(wantedSize) && values.includes(wantedColour) && variant.available;
  });

  if (!match) {
    match = variants.find(variant => {
      const values = [variant.option1, variant.option2, variant.option3].filter(Boolean).map(normalizeOption);
      return values.includes(wantedSize) && variant.available;
    });
  }

  if (!match) match = variants.find(variant => variant.available);
  return match || null;
}

function updateCartBadge(total) {
  const badge = document.getElementById('cartBadge');
  if (!badge) return;
  badge.textContent = total;
  badge.classList.toggle('show', total > 0);
}

async function fetchShopifyCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Could not load cart');
  return response.json();
}

async function addShopifyVariant(variantId, quantity) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1) })
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || error.message || 'Could not add item to cart');
  }

  return response.json();
}

async function changeShopifyCartLine(key, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || error.message || 'Could not update cart');
  }

  return response.json();
}

async function renderCart() {
  const body = document.getElementById('cdBody');
  const empty = document.getElementById('cdEmpty');
  const count = document.getElementById('cdCount');
  const totalEl = document.getElementById('cdTotal');
  if (!body || !empty || !count || !totalEl) return;

  let cart;
  try { cart = await fetchShopifyCart(); }
  catch (error) { console.error(error); return; }

  const total = cart.item_count || 0;
  updateCartBadge(total);
  count.textContent = total + ' item' + (total !== 1 ? 's' : '');
  totalEl.textContent = moneyFromCents(cart.total_price || 0);

  body.innerHTML = '';

  if (!cart.items || cart.items.length === 0) {
    body.appendChild(empty);
    empty.style.display = 'flex';
    return;
  }

  empty.style.display = 'none';

  cart.items.forEach(item => {
    const image = item.image || '';
    const options = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const el = document.createElement('div');
    el.className = 'cd-item';
    el.innerHTML = `
      <img class="cd-item-img" src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}">
      <div>
        <div class="cd-item-brand">Ovena Health</div>
        <div class="cd-item-name">${escapeHtml(item.product_title)}</div>
        <div class="cd-item-meta">${escapeHtml(options)}</div>
        <div class="cd-qty">
          <button class="cd-qty-btn" type="button" data-stride-cart-action="decrease" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}">−</button>
          <span class="cd-qty-val">${item.quantity}</span>
          <button class="cd-qty-btn" type="button" data-stride-cart-action="increase" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity}">+</button>
        </div>
        <button class="cd-remove" type="button" data-stride-cart-action="remove" data-key="${escapeHtml(item.key)}">Remove</button>
      </div>
      <div class="cd-item-price">${moneyFromCents(item.final_line_price)}</div>
    `;
    body.appendChild(el);
  });
}

async function addToCart(pid, name, img, price) {
  const { size, colour } = getSelections(pid);
  const variant = findStrideVariant(pid, size, colour);

  if (!variant) {
    showToast('No variant available for this selection. Please choose another size or colour.');
    return;
  }

  try {
    await addShopifyVariant(variant.id, 1);
    await renderCart();
    showToast(name + ' (' + colour + ', Size ' + size + ') added to cart');
    openCart();
  } catch (error) {
    console.error(error);
    showToast(error.message || 'Could not add item to cart');
  }
}

function swapColour(sw, pid, col, label) {
  const card = document.querySelector('[data-pid="' + pid + '"]');
  if (!card) return;
  card.querySelectorAll('.pswatch').forEach(s => s.classList.remove('active'));
  sw.classList.add('active');
  const img = document.getElementById('pimg-' + pid);
  if (img && img.dataset[col]) img.src = img.dataset[col];
  const lbl = document.getElementById('clabel-' + pid);
  if (lbl) lbl.textContent = label;
}

function pickSize(btn, wrapId) {
  const wrap = document.getElementById(wrapId);
  if (!wrap) return;
  wrap.querySelectorAll('.szpill').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

function showSizeGuide() {
  showToast('I ≤ 7.5 in · II = 7.5–8.5 in · III = 8.5–9.5 in · IV = 9.5–10.5 in · V = 10.5–12 in ankle circumference.');
}

function openCart() {
  const overlay = document.getElementById('cartOverlay');
  const drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.classList.add('open');
  if (drawer) drawer.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}

function closeCart() {
  const overlay = document.getElementById('cartOverlay');
  const drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.classList.remove('open');
  if (drawer) drawer.classList.remove('open');
  document.body.style.overflow = '';
}

async function doCheckout() {
  try {
    const cart = await fetchShopifyCart();
    if (!cart.item_count) {
      showToast('Your cart is empty');
      return;
    }
    window.location.href = '/checkout';
  } catch (error) {
    console.error(error);
    window.location.href = '/checkout';
  }
}

function openLogin() {
  const overlay = document.getElementById('loginOverlay');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeLogin() {
  const overlay = document.getElementById('loginOverlay');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

function overlayClick(e, id) {
  if (e.target.id === id) {
    if (id === 'loginOverlay') closeLogin();
    else closeCart();
  }
}

function toRegister() {
  const login = document.getElementById('loginView');
  const register = document.getElementById('registerView');
  if (login) login.style.display = 'none';
  if (register) register.style.display = 'block';
}

function toLogin() {
  const register = document.getElementById('registerView');
  const login = document.getElementById('loginView');
  if (register) register.style.display = 'none';
  if (login) login.style.display = 'block';
}

function doLogin() {
  const e = document.getElementById('lemail')?.value;
  const p = document.getElementById('lpass')?.value;
  if (!e || !p) {
    showToast('Please enter your email and password');
    return;
  }
  closeLogin();
  showToast('Welcome back. Signed in successfully.');
}

function doRegister() {
  closeLogin();
  showToast('Account created. Welcome to Ovena Health.');
}

let toastTimer;
function showToast(msg) {
  const t = document.getElementById('toast');
  const msgEl = document.getElementById('toastMsg');
  if (!t || !msgEl) return;
  msgEl.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 3200);
}

document.addEventListener('click', async event => {
  const btn = event.target.closest('[data-stride-cart-action]');
  if (!btn) return;

  const action = btn.dataset.strideCartAction;
  const key = btn.dataset.key;
  const qty = Number(btn.dataset.qty || 0);
  if (!key) return;

  try {
    if (action === 'increase') await changeShopifyCartLine(key, qty + 1);
    if (action === 'decrease') await changeShopifyCartLine(key, Math.max(0, qty - 1));
    if (action === 'remove') await changeShopifyCartLine(key, 0);
    await renderCart();
  } catch (error) {
    console.error(error);
    showToast(error.message || 'Could not update cart');
  }
});

window.swapColour = swapColour;
window.pickSize = pickSize;
window.showSizeGuide = showSizeGuide;
window.addToCart = addToCart;
window.openCart = openCart;
window.closeCart = closeCart;
window.doCheckout = doCheckout;
window.openLogin = openLogin;
window.closeLogin = closeLogin;
window.overlayClick = overlayClick;
window.toRegister = toRegister;
window.toLogin = toLogin;
window.doLogin = doLogin;
window.doRegister = doRegister;
window.showToast = showToast;

renderCart();
